import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';

interface UseSendUrlPromptMessageProps {
  np: string | undefined;
  sig: string | undefined;
  isLoadingHistory: boolean;
  transparencyCheckRequired: boolean;
  submitUrlPromptMessage(args: {
    encodedPrompt: string;
    encodedSignature: string;
  }): Promise<void>;
}

export const useSendUrlPromptMessage = ({
  np,
  sig,
  isLoadingHistory,
  transparencyCheckRequired,
  submitUrlPromptMessage,
}: UseSendUrlPromptMessageProps) => {
  const history = useHistory();
  const location = useLocation();
  // submitUrlPromptMessage is recreated on every render of useConversationHistory,
  // so guarding via deps alone would let the effect re-fire indefinitely.
  const hasSubmittedRef = useRef(false);

  useEffect(() => {
    if (
      !np ||
      !sig ||
      isLoadingHistory ||
      transparencyCheckRequired ||
      hasSubmittedRef.current
    ) {
      return;
    }

    hasSubmittedRef.current = true;

    void submitUrlPromptMessage({
      encodedPrompt: np,
      encodedSignature: sig,
    });

    const params = new URLSearchParams(location.search);
    params.delete('np');
    params.delete('sig');
    const remaining = params.toString();
    history.replace(
      `${location.pathname}${remaining ? `?${remaining}` : ''}${location.hash}`,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    np,
    sig,
    isLoadingHistory,
    transparencyCheckRequired,
    submitUrlPromptMessage,
  ]);
};
